import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AsBadge',
  props: {
    count: { default: 0 },
    dot: { type: Boolean, default: false },
    max: { default: 99 },
    inline: { type: Boolean, default: false },
    showZero: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const visible = computed(() => {
  if (props.dot) return props.count > 0 || props.showZero
  return props.count > 0 || props.showZero
})

const displayValue = computed(() => {
  if (props.count > props.max) return `${props.max}+`
  return String(props.count)
})

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["asBadge", { '-dot': _ctx.dot, '-inline': _ctx.inline }])
      }, [
        (!_ctx.dot)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(displayValue.value), 1)
            ], 64))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})